import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams, IAfterGuiAttachedParams } from 'ag-grid-community';

@Component({
    selector: 'app-actionCheckBox',
    template: `

    <div style="display: flex; align-items: center;">
  <input
    type="checkbox"
    (change)="onHeaderCheckboxChange($event)"
    style="margin-left:8px;margin-right: 6px; transform: scale(1.2); background: #F4C430;" />
    
  <span style="margin-left:15px">Action</span>
</div>


  `,
    standalone: false
})


export class CustomCheckButton implements ICellRendererAngularComp {

  params:any;
  label: string;
  defaultcheckbox: any = [];

  // agInit(params): void {
  //   this.params = params;
  //   console.log(this.params);
  //   this.defaultcheckbox = this.params.data;
  //   this.defaultcheckbox.selectinstance === "1" ? this.defaultcheckbox.selectinstance = true : this.defaultcheckbox.selectinstance = false;
  //   // this.label = this.params.label || null;
  // }

  refresh(params?: any): boolean {
    return true;
  }

  // updateCheckbox($event) {
  //   console.log($event)
  //   console.log(this.params.updateCheckbox)
  //   if (this.params.updateCheckbox instanceof Function) {
  //     // put anything into params u want pass into parents component
  //     const params = {
  //       event: $event,
  //       rowData: this.params.node.data
  //       // ...something
  //     }
  //     console.log(params)
  //     this.params.updateCheckbox(params);

  //   }
  // }
  agInit(params: any): void {
    this.params = params;
  }

  onHeaderCheckboxChange(event: any): void {
    const checked = event.target.checked;

    // Notify parent via callback
     console.log('Header checkbox clicked:', checked); // ✅ Ensure this prints
    this.params.updateCheckbox?.(checked); 
  }

}
